/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Employee } from './Employee';
import {
    EmployeeFromJSON,
    EmployeeFromJSONTyped,
    EmployeeToJSON,
    EmployeeToJSONTyped,
} from './Employee';

/**
 * 
 * @export
 * @interface ConfirmEmployeeResponse
 */
export interface ConfirmEmployeeResponse {
    /**
     * 
     * @type {Employee}
     * @memberof ConfirmEmployeeResponse
     */
    data: Employee;
}

/**
 * Check if a given object implements the ConfirmEmployeeResponse interface.
 */
export function instanceOfConfirmEmployeeResponse(value: object): value is ConfirmEmployeeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ConfirmEmployeeResponseFromJSON(json: any): ConfirmEmployeeResponse {
    return ConfirmEmployeeResponseFromJSONTyped(json, false);
}

export function ConfirmEmployeeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmEmployeeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeeFromJSON(json['data']),
    };
}

  export function ConfirmEmployeeResponseToJSON(json: any): ConfirmEmployeeResponse {
      return ConfirmEmployeeResponseToJSONTyped(json, false);
  }

  export function ConfirmEmployeeResponseToJSONTyped(value?: ConfirmEmployeeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeeToJSON(value['data']),
    };
}

